import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Text = styled.p<{theme: Theme}>`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  color: ${({theme}) => theme.alert};
  margin-left: 10px;
  margin-top: 2px;
`;
